import { Home, Globe, FileText, Activity, Settings } from "lucide-react";

const navItems = [
  { label: "Dashboard", icon: Home },
  { label: "Targets", icon: Globe },
  { label: "Reports", icon: FileText },
  { label: "Traffic", icon: Activity },
  { label: "Settings", icon: Settings }
];

export default function Sidebar() {
  return (
    <aside className="h-screen bg-sidebar-DEFAULT border-r border-sidebar-border flex flex-col min-w-[210px] px-4 py-6 gap-4">
      <div className="flex items-center gap-2 mb-8">
        <span className="rounded bg-sidebar-primary text-sidebar-primary-foreground p-2 text-lg font-bold shadow">
          AcunaScan
        </span>
      </div>
      <nav className="flex flex-col gap-1 flex-1">
        {navItems.map(({ label, icon: Icon }) => (
          <button
            key={label}
            className="flex items-center gap-3 px-3 py-2 rounded-md font-medium text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground transition-colors"
          >
            <Icon size={20} strokeWidth={2.2} />
            <span>{label}</span>
          </button>
        ))}
      </nav>
      <div className="mt-auto text-xs text-sidebar-foreground text-center opacity-60">
        &copy; {new Date().getFullYear()} AcunaScan
      </div>
    </aside>
  );
}